import React, { FC, useEffect } from 'react';

import { Loader } from '$shared/components';
import { useDispatch } from 'react-redux';
import { authActions } from '$store/auth';

export const AuthEmail: FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.validateEmailAuth());
  }, []);

  return (
    <>
      <Loader isWrapped />
    </>
  );
};
